import React from 'react';

export const LazySystemPage = React.lazy(() => import('./SystemPage'));
